import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { useState, useRef, useEffect } from "react";
import { AddKnowledge } from "./components/AddKnowledge";
import { api } from "@/api/client";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PaginationComponent } from "@/components/Pagination";
import { ConfirmDialog } from "@/components/ConfirmDialog";

// 定义表格数据类型
interface User {
  id: string;
  name: string;
  email: string;
  role: string;
  status: "active" | "inactive" | "pending";
}

// 示例数据
const initialData: User[] = [
  {
    id: "1",
    name: "John Doe",
    email: "john@example.com",
    role: "Admin",
    status: "active",
  },
  {
    id: "2",
    name: "Jane Smith",
    email: "jane@example.com",
    role: "User",
    status: "active",
  },
  {
    id: "3",
    name: "Bob Johnson",
    email: "bob@example.com",
    role: "Editor",
    status: "inactive",
  },
  {
    id: "4",
    name: "Alice Williams",
    email: "alice@example.com",
    role: "User",
    status: "pending",
  },
];

export default function knowledge() {
  const navigate = useNavigate();

  const [list, setList] = useState([]);
  const [DialogData, setDialogData] = useState({
    title: "",
    description: "",
    confirmText: "",
  });

  // 在组件挂载后设置翻译
  useEffect(() => {
    setDialogData({
      title: t("confirmDeleteTitle"),
      description: t("confirmDeleteDescription"),
      confirmText: t("common.confirm"),
    });
  }, []);

  // 状态管理
  const [data, setData] = useState<User[]>([]);
  // const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // 创建弹窗的引用
  const deleteDialogRef = useRef<any>(null);

  // 分页参数
  const [queryParams, setQueryParams] = useState({
    page: 1,
    size: 10,
  });
  const [total, setTotal] = useState(0); // 总条数

  // 获取列表数据
  const getList = async () => {
    try {
      setLoading(true);
      // 调用 GET 请求
      const response: any = await api.get("/v1/admin/knowledge/files", {
        params: {
          ...queryParams,
          // 其他查询参数
        },
      });
      console.log(response);
      setData(response.content); // 存储接口返回的数据
      setTotal(response.page.totalElements);
    } catch (err) {
      console.error("获取团队用户失败:", err);
      setError("加载用户失败，请刷新页面重试");
    } finally {
      setLoading(false); // 无论成功失败，都结束加载状态
    }
  };
  // 更新列表数据的方法
  const upList = async (page: number, limit: number) => {
    // 更新参数
    setQueryParams({
      ...queryParams,
      page: page,
      size: limit,
    });

    // 调用API获取数据
    console.log(`获取第${page}页，每页${limit}条数据`);
  };
  useEffect(() => {
    getList();
  }, [queryParams.page, queryParams.size]); // 空依赖数组表示只在组件挂载时执行一次
  // useEffect(() => {
  //     getList(queryParams.page,queryParams.size);
  // }, [queryParams.page, queryParams.size]);

  // 搜索功能
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);

    // 过滤数据
    const filtered = data.filter(
      (item) =>
        item.name.toLowerCase().includes(value) ||
        item.email.toLowerCase().includes(value) ||
        item.role.toLowerCase().includes(value)
    );
    setData(filtered);
  };

  const openDialog = () => {
    deleteDialogRef.current?.open();
    //這裡要拿下id
  };
  // 删除行
  const handleDelete = () => {
    if (DialogData.confirmText === "复制") {
      //复制
      navigator.clipboard.writeText(DialogData.description);
    } else {
      console.log("执行删除操作...");
    }

    return;
    // setData(data.filter((item) => item.id !== id));
  };
  // 创建弹窗引用
  const addUserDialogRef = useRef<{ open: () => void }>(null);
  // 新增成功后的回调
  const handleAddSuccess = (res: any) => {
    console.log(res);
    if (res.type === "LINK") {
      setDialogData({
        title: "请复制链接邀请用户",
        description: res.link,
        confirmText: t("common.copy"),
      });
      openDialog();
    }
    console.log("用户新增成功，刷新列表...");
  };

  // 获取状态标签样式
  const getStatusBadge = (status: User["status"]) => {
    switch (status) {
      case "active":
        return (
          <span className="px-2 py-1 text-xs bg-green-100 text-green-800 rounded-full">
            Active
          </span>
        );
      case "inactive":
        return (
          <span className="px-2 py-1 text-xs bg-red-100 text-red-800 rounded-full">
            Inactive
          </span>
        );
      case "pending":
        return (
          <span className="px-2 py-1 text-xs bg-yellow-100 text-yellow-800 rounded-full">
            Pending
          </span>
        );
      default:
        return null;
    }
  };

  return (
    <main className="pl-4 pr-4 py-12 pt-0 mt-15 min-h-screen bg-background">
      <div className="space-y-4">
        <div className="flex justify-between items-center mx-auto space-y-4 mt-20">
          <h2 className="text-xl font-bold mb-0">
            知識庫
            <Input
              style={{ display: "inline-block", marginLeft: "10px" }}
              placeholder="搜索..."
              value={searchTerm}
              onChange={handleSearch}
              className="w-64"
            />
          </h2>
          <div className="space-x-2">
            <Button onClick={() => addUserDialogRef.current?.open()}>
              創建知識庫
            </Button>
          </div>
        </div>

        <Table>
          <TableHeader style={{ background: "#f2f2f2" }}>
            <TableRow>
              <TableHead>知識庫名稱</TableHead>
              <TableHead>文件數量</TableHead>
              <TableHead>創建人</TableHead>
              <TableHead>創建時間</TableHead>
              <TableHead className="text-right">操作</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.length === 0 ? (
              <TableRow>
                <TableCell colSpan={12} className="text-center py-8">
                  <div style={{ color: "#b1b0b0" }}>暫無數據</div>
                </TableCell>
              </TableRow>
            ) : (
              data.map((item) => (
                <TableRow key={item.id}>
                  <TableCell className="font-medium">{item.name}</TableCell>
                  <TableCell>{item.email}</TableCell>
                  <TableCell>{item.role}</TableCell>
                  <TableCell>{item.role}</TableCell>
                  <TableCell>{item.role}</TableCell>
                  <TableCell>{"2025-07-09 17:20"}</TableCell>

                  {/*onClick={() => handleDelete(item.id)}*/}
                  <TableCell className="text-right">
                    <div className="text-red-600">
                      <div onClick={() => openDialog()}>刪除</div>
                    </div>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>

        {/* 分页组件 */}
        {total > 0 && (
          <PaginationComponent
            total={total}
            page={queryParams.page}
            limit={queryParams.size}
            pageSizes={[10, 20, 30, 50]}
            onPagination={upList}
            prevNextType="icon"
          />
        )}
      </div>
      {/* 确认弹窗 */}
      <ConfirmDialog
        ref={deleteDialogRef}
        title={DialogData.title}
        description={DialogData.description}
        confirmText={DialogData.confirmText}
        onConfirm={handleDelete}
      />
      {/* 新增用户弹窗 */}
      <AddKnowledge ref={addUserDialogRef} onSuccess={handleAddSuccess} />
    </main>
  );
}
